<template>
    <main style="max-width: 100% !important; z-index: 999 !important" v-if="productData.paypal_upsell">
        <div class="extra-popup custom-extra-popup golden-layout double-display" style="display: block; z-index: 999 !important">
            <div class="wrap-scroll">
                <div class="wrap-inner">
                    <div class="wrap-modal">
                        <div class="head-modal">
                            <p class="d-inline-flex align-items-center justify-content-center">
                                <PaypalLogo width="100px" height="30px" class="position-relative"/>
                                {{ props.heading }}
                                <strong style="display: block">{{ props.text }}
                                    <br class="hidden-md-up"/><u>
                                        <span class="savePrice">
                                            {{
                                            $filters.money(
                                              props.price,
                                              currencyLocale,
                                              currencyCode
                                            )}}
                                        </span></u></strong>
                            </p>
                        </div>
                        <div class="body-modal">
                            <div class="addition-content" style="max-height: 210px">
                                <picture>
                                    <img :srcset="props.image" alt="" class="w-full mx-auto lazyload" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="/>
                                </picture>
                            </div>
                        </div>
                        <div class="footer-modal" data-btnaddid="btnadd" data-btncancelid="btncancel">
                            <div class="section-button">
                                <a class="btn-add" href="#" v-on:click="paypalUpsellYes">{{ props.upsellYes }}</a>
                                <a class="btn-cancel" href="#" v-on:click="submit()">{{ props.upsellNo }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script setup>
import PaypalLogo from "../assets/PaypalLogo.vue";

const productData = window.productData

const currencyCode = productData.currency_code;
const currencyLocale = productData.currency_locale;
import {useCartStore} from "../../state/cart";
import {ref, reactive} from "vue";
import axios from "axios";

const loading = ref(false);

const props = defineProps({
    heading: String,
    text: String,
    upsellYes: String,
    upsellNo: String,
    price: String,
    image: String,
    konnektiveCampaignId: String
})

const emits = defineEmits(['loading'])


const cart = useCartStore();


if (!productData.paypal_upsell) {
    submit();
}

function paypalUpsellYes() {
    return submit(productData.paypal_upsell_settings)
}

function submit(upsell = null) {

    loading.value = true;
    emits('loading', true)

    const data = {
        products: cart.$state,
        upsell: upsell,
        thankYou: productData.paypal_thank_you_page,
        return_to: window.location.href,
        affiliate: window.affiliate,
    }

    axios.post('/wp-json/checkout/v1/order/paypal', data).then((response) => {
        const result = response.data
        loading.value = false;
        emits('loading', false)

        if (result.result === 'ERROR') {
            // Validation / Payment error
            alert (response.error);
        } else {
            window.location.href = result;
        }
    }).catch((response) => {
        console.log(response.status, response.statusText);
    });
}
</script>

<style>
.paypal_logo {
    top: -5px;
}
</style>